import type { HttpClient } from "@/lib/http";
import { http } from "@/lib/http";

import type { NotificationCounts } from "@/features/notifications/types";

import type { NotificationCountsDto } from "./dto";
import { mapNotificationCounts } from "./mappers";

/**
 * The only place that knows the notification-counts transport. Factory takes the
 * HTTP client so tests/MSW can inject a mock-pointed client. Migrating to
 * GraphQL later = reimplement this interface's internals only.
 */
export interface NotificationsRepository {
  getCounts(): Promise<NotificationCounts>;
}

export function createNotificationsRepository(
  client: HttpClient,
): NotificationsRepository {
  return {
    async getCounts() {
      const dto = await client.get<NotificationCountsDto>(
        "/api/v1/dashboard/notification",
      );
      return mapNotificationCounts(dto);
    },
  };
}

/** Default repository wired to the app's singleton HTTP client. */
export const notificationsRepository = createNotificationsRepository(http);
